import React from 'react'

const CommonTermsAndConditions = () => {
    return (
        <>
           <div className="fw-semibold text-gray-600 fs-6 d-block mb-6">
                <ol className='mb-6 lh-lg'>
                    <li className='text-gray-800 fs-5'>
                        TruVoice - Terms and Conditions
                        These Terms and Conditions (“Terms”) are a legally binding agreement between you (“User,” “you,” or “your”) and TruVoice Technologies Private Limited (“TruVoice,” “we,” “us,” or “our”), an Indian company headquartered in 2nd Floor, 20, Inorbit Mall Rd, Mindspace Rd, Vittal Rao Nagar, Madhapur, Telangana 500081.
                    </li>
                </ol>
                <ol className='mb-6 lh-lg'>
                    <li className='text-gray-800 fs-5'>
                        By accessing or using our platform and services, you agree to be bound by these Terms. If you do not accept these Terms, you may not use TruVoice.
                    </li>
                </ol>
                <ol className='mb-6 lh-lg'>
                    <li className='text-gray-800 fw-bold mb-6 fs-2x'>
                        1. Eligibility
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        You may use the TruVoice platform only if:
                    </li>
                    <li  className='text-gray-800 fs-5 ms-6'>
                        You are at least 18 years old or of legal age in your jurisdiction,
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        You have full legal capacity and authority to enter into these Terms,
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        Your use complies with all local laws and regulations applicable to you.
                    </li>
                </ol>
                <ol className='mb-6 lh-lg'>
                    <li className='text-gray-800 fw-bold mb-6 fs-2x'>
                        2. Account Registration and Security
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        You must provide accurate and up-to-date information when registering. You are solely responsible for:
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        Keeping your login credentials confidential,
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        All actions taken through your account, authorized or otherwise.
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        We reserve the right to disable or terminate your account if we believe it violates these Terms or any applicable law.
                    </li>
                </ol>
                <ol className='mb-6 lh-lg'>
                    <li className='text-gray-800 fw-bold mb-6 fs-2x'>
                        3. Permitted Use
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        TruVoice provides tools to build, deploy, and manage AI agents. You agree to:
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        Use the platform for lawful, ethical, and permitted purposes,
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        Comply with regional laws, including but not limited to data protection, AI usage, and export laws,
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        Avoid using the platform to harm others, deceive users, or spread misinformation.
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        Prohibited uses include:
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        Creating AI agents for malicious, discriminatory, or illegal purposes,
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        Impersonating individuals or entities without consent,
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        Tampering with or reverse-engineering the platform.
                    </li>
                </ol>
                <ol className='mb-6 lh-lg'>
                    <li className='text-gray-800 fw-bold mb-6 fs-2x'>
                        4. User Content and Intellectual Property
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        4.1 Your Rights
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        You retain ownership of AI agents and other content you create on the platform (“User Content”).
                    </li>
                </ol>
                <ol className='mb-6 lh-lg'>
                    <li className='text-gray-800 fw-bold mb-6 fs-2x'>
                        4.2 License to TruVoice
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        By uploading or creating User Content, you grant TruVoice a non-exclusive, worldwide, royalty-free license to use, store, process, display, and distribute your content strictly for the purpose of operating and improving our services.
                    </li>
                </ol>
                <ol className='mb-6 lh-lg'>
                    <li className='text-gray-800 fw-bold mb-6 fs-2x'>
                        5. Privacy and Data Protection
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        We process your data in accordance with our Privacy Policy, which complies with:
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        Indian Data Protection Laws (DPDP Bill/Act),
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        General Data Protection Regulation (GDPR) (EU),
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        California Consumer Privacy Act (CCPA) (USA), where applicable.
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        By using the platform, you consent to the transfer and storage of your data on servers located in India and other jurisdictions as necessary to provide global services.
                    </li>
                </ol>
                <ol className='mb-6 lh-lg'>
                    <li className='text-gray-800 fw-bold mb-6 fs-2x'>
                        6. Third-Party Integrations
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        TruVoice may integrate with third-party tools and services (e.g., APIs, cloud hosting). These are governed by their respective terms and privacy policies. TruVoice is not liable for third-party services outside our control.
                    </li>
                </ol>
                <ol className='mb-6 lh-lg'>
                    <li className='text-gray-800 fw-bold mb-6 fs-2x'>
                        7. Disclaimers
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        The platform is provided “as is” and “as available.”
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        We do not warrant that:
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        The platform will be uninterrupted or error-free,
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        AI agents created on the platform will always behave as intended,
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        The platform is suitable for every jurisdiction.
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        Use of TruVoice is at your sole risk.
                    </li>
                </ol>
                <ol className='mb-6 lh-lg'>
                    <li className='text-gray-800 fw-bold mb-6 fs-2x'>
                        8. Limitation of Liability
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        To the maximum extent permitted by law, TruVoice shall not be liable for:
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        Indirect or consequential damages,
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        Loss of data, revenue, business, or profits,
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        Issues caused by third-party services or AI behavior.
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        Our liability in any case will not exceed the fees (if any) paid by you to us in the six months preceding the claim.
                    </li>
                </ol>
                <ol className='mb-6 lh-lg'>
                    <li className='text-gray-800 fw-bold mb-6 fs-2x'>
                        9. Termination
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        TruVoice may suspend or terminate your access to the platform at any time:
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        For breach of these Terms,
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        If required by law,
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        For conduct that harms TruVoice or other users.
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        Upon termination, your rights to use the platform cease, and we may delete your account and related data, unless legally required to retain it.
                    </li>
                </ol>
                <ol className='mb-6 lh-lg'>
                    <li className='text-gray-800 fw-bold mb-6 fs-2x'>
                        10. Global Compliance and Export Control
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        You agree to comply with all applicable:
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        Local laws and regulations in your country,
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        International export control laws, including those of India, the United States, and the EU.
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        You may not use the platform if you are subject to Indian, U.S., or international sanctions or on any prohibited party list.
                    </li>
                </ol>
                <ol className='mb-6 lh-lg'>
                    <li className='text-gray-800 fw-bold mb-6 fs-2x'>
                        11. Changes to These Terms
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        We may modify these Terms at any time. If changes are material, we will notify you via email or platform notification. Continued use of TruVoice after updates indicates your acceptance of the revised Terms.
                    </li>
                </ol>
                <ol className='mb-6 lh-lg'>
                    <li className='text-gray-800 fw-bold mb-6 fs-2x'>
                        12. Governing Law and Jurisdiction
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        These Terms are governed by the laws of India, without regard to its conflict of law rules.
                    </li>
                </ol>
                <ol className='mb-6 lh-lg'>
                    <li className='text-gray-800 fw-bold mb-6 fs-2x'>
                        12.1 Jurisdiction
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        Any dispute, claim, or controversy arising out of or relating to these Terms shall be subject to the exclusive jurisdiction of the courts of Telangana, India.
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        If you are a consumer residing outside India, you may also be entitled to certain protections under the mandatory laws of your local jurisdiction.
                    </li>
                </ol>
                <ol className='mb-6 lh-lg'>
                    <li className='text-gray-800 fw-bold mb-6 fs-2x'>
                        13. Miscellaneous
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        Entire Agreement: These Terms and the Privacy Policy represent the entire agreement between you and TruVoice.
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        Severability: If any part is held unenforceable, the rest remains valid.
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        No Waiver: Our failure to enforce a provision does not waive our rights.
                    </li>
                </ol>
                <ol className='mb-6 lh-lg'>
                    <li className='text-gray-800 fw-bold mb-6 fs-2x'>
                        Contact Information
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        Julien Innovations India Pvt. Ltd
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        2nd Floor, 20, Inorbit Mall Rd, Mindspace Rd, Vittal Rao Nagar, Madhapur, Telangana 500081
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        Email: admin@truvoice.ai
                    </li>
                    <li className='text-gray-800 fs-5 ms-6'>
                        Website: https://truvoice.ai
                    </li>
                </ol>
            </div>
        </>
    )
}

export default CommonTermsAndConditions